import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { DataService } from "../../../_services/data.service";
import { AuthenticationService } from "../../../_services/authentication.service";

import { Router } from "@angular/router";
import { EventsService } from "../../../_services/eventsServices/events.service";

import { FormControl, FormGroup, Validators } from "@angular/forms";
import { RowEventTypeEmit } from "../../events-screen/event-page-models/row-event-type-emit";
import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";
import { trimTextByWord } from "../../events-screen/utils/trimTextByWord";
import { ParentEventMessageType } from "../../events-screen/event-page-models/parent-event-message";
import {
  EventCircleIndex,
  EventTypeData,
} from "../../../_models/event-type-data";

@Component({
  selector: "events-type-management-row",
  templateUrl: "./events-type-management-row.component.html",
  styleUrls: ["./events-type-management-row.component.scss"],
})
export class EventsTypeManagementRowComponent implements OnInit, OnDestroy {
  public isInEdit: boolean = false;
  @Output("rowEvent") public rowEvent: EventEmitter<RowEventTypeEmit> =
    new EventEmitter<RowEventTypeEmit>();
  @Input() public eventType: EventTypeData;
  public eventTypeFormGroup: FormGroup | null = null;
  public circleIndexNames: string[] = [];

  constructor(
    private eventService: EventsService,
    private dataService: DataService,
    private sessionManage: SessionManagerService,
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  public _editEventTypeId: number;

  @Input("editEventTypeId")
  public set editEventTypeId(value: number) {
    if (this._editEventTypeId === value) {
      return;
    }
    this._editEventTypeId = value;

    this.setEditMode(value.toString() === this.eventType.id.toString());
  }

  public static createCircleIndexFormName(circleId: string): string {
    return `circle_${circleId}`;
  }

  public ngOnInit(): void {}

  ngOnDestroy(): void {}

  public formatDate(date: Date) {
    return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
  }

  clickSelect($event: Event) {
    $event.stopPropagation();
    $event.stopPropagation();
  }

  public rowClicked($event): void {}

  public trimText(text: string) {
    return trimTextByWord(text, 14);
  }

  public editRow($event: MouseEvent) {
    this.rowEvent.emit({
      action: "startEdit",
      eventTypeId: this.eventType.id,
      data: null,
    });
  }

  public cancelEdit($event: MouseEvent) {
    this.rowEvent.emit({
      action: "cancelEdit",
      eventTypeId: this.eventType.id,
      data: null,
    });
  }

  public saveRow($event: MouseEvent) {
    const formValues: Partial<EventTypeData> = this.eventTypeFormGroup.value;
    if (!this.eventTypeFormGroup.valid) {
      this.eventService.setParentEventMessage({
        text: "סוג ארוע חייב להכיל שם ואינדקס ברירת מחדל",
        type: ParentEventMessageType.Info,
      });
      return;
    }

    const circlesIndexes: EventCircleIndex[] = this.eventType.indexes.map(
      (eci) => {
        const oneEventCircleIndex: EventCircleIndex = {
          ...eci,
        };
        const formValue =
          formValues[
            EventsTypeManagementRowComponent.createCircleIndexFormName(
              eci.circleId
            )
          ];
        oneEventCircleIndex.value = formValue;
        return oneEventCircleIndex;
      }
    );
    const eventTypeToSave: EventTypeData = {
      defaultIndex: formValues.defaultIndex,
      name: formValues.name,
      id: this.eventType.id,
      isMultiday: formValues.isMultiday,
      indexes: circlesIndexes,
      isVisible: formValues.isVisible,
    };

    this.rowEvent.emit({
      action: "save",
      eventTypeId: this.eventType.id,
      data: eventTypeToSave,
    });
  }

  private setEditMode(inEdit: boolean = true) {
    this.isInEdit = inEdit;

    this.circleIndexNames = [];
    if (inEdit) {
      this.eventTypeFormGroup = new FormGroup({
        name: new FormControl(this.eventType.name),
        isVisible: new FormControl(this.eventType.isVisible),
        isMultiday: new FormControl(this.eventType.isMultiday),
        defaultIndex: new FormControl(
          this.eventType.defaultIndex,
          Validators.min(1)
        ),
        indexes: new FormGroup({}),
      });
      const circleIndexNames = [];

      this.eventType.indexes.forEach((oneIndex) => {
        const formControlName =
          EventsTypeManagementRowComponent.createCircleIndexFormName(
            oneIndex.circleId
          );
        this.eventTypeFormGroup.addControl(
          formControlName,
          new FormControl(oneIndex.value)
        );
        circleIndexNames.push(formControlName);
      });
      this.circleIndexNames = circleIndexNames;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/event-type-management/events-type-row/events-type-management-row.component.ts